// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"e697577c","453":"93a882f7","577":"0aab1b02","598":"08994050","727":"c2887a34","738":"1d3922a8","784":"7fa0f202","825":"35411b91","984":"7595c1b4"}[chunkId] + ".chunk.js";
};